<template>
    <div class="p-3">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h4 class="text-gray-800 font-weight-bold m-0">Mis Recibos de Nómina</h4>
        </div>
        
        <div class="table-responsive rounded-lg shadow-sm border border-light">
            <table class="table table-hover mb-0 custom-table">
                <thead class="bg-light-gray">
                    <tr>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0 pl-4">Periodo</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0">Tipo de Pago</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0">Registro Patronal</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0">Folio Fiscal</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0">Archivo</th>
                        <th class="text-uppercase text-secondary font-weight-bold text-xs border-0 text-right pr-4">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="receipt in receipts" :key="receipt.id">
                        <td class="align-middle pl-4 font-weight-bold text-dark">
                            {{ formatPeriod(receipt) }}
                        </td>
                        <td class="align-middle text-muted">{{ receipt.payment_type }}</td>
                        <td class="align-middle text-dark">{{ receipt.employer_register }}</td>
                        <td class="align-middle text-dark">{{ receipt.fiscal_folio }}</td>
                        <td class="align-middle">
                            <div class="d-flex align-items-center">
                                <i :class="getFileIcon(receipt.filename)" class="mr-2 text-teal"></i>
                                <span class="text-muted small">{{ receipt.filename }}</span>
                            </div>
                        </td>
                        <td class="align-middle text-right pr-4">
                            <button class="btn btn-icon btn-light btn-sm rounded-circle shadow-sm text-teal hover-scale" @click="downloadReceipt(receipt)" title="Descargar archivo">
                                <i class="fas fa-download"></i>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="receipts.length === 0">
                        <td colspan="6" class="text-center py-5 text-muted">
                            <div class="d-flex flex-column align-items-center">
                                <i class="fas fa-folder-open fa-3x mb-3 text-gray-300"></i>
                                <p class="m-0">No hay recibos de nómina disponibles.</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import request from '@/services/request';

export default {
    props: ['userId'],
    data() {
        return {
            receipts: []
        };
    },
    watch: {
        userId: {
            immediate: true,
            handler(val) {
                if (val) this.fetchReceipts();
            }
        }
    },
    methods: {
        async fetchReceipts() {
            try {
                const { data } = await request.get(`/payroll_receipts/${this.userId}`);
                this.receipts = data;
            } catch (error) {
                console.error(error);
            }
        },
        formatPeriod(receipt) {
            const periodName = receipt.payment_type === 'Quincenal' ? 'Quincena' : 'Periodo';
            return `${periodName} ${receipt.period} - ${receipt.year}`;
        },
        getFileIcon(filename) {
            const ext = filename.split('.').pop().toLowerCase();
            if (ext === 'pdf') return 'fas fa-file-pdf';
            if (ext === 'zip') return 'fas fa-file-archive';
            return 'fas fa-file';
        },
        async downloadReceipt(receipt) {
            // Si es un link de OneDrive (synced), lo abrimos en nueva pestaña
            if (receipt.sync_status === 'synced' || (receipt.file_path && receipt.file_path.startsWith('http'))) {
                window.open(receipt.file_path+"?web=1", '_blank');
                return;
            }

            // Si es local (pending), usamos la descarga por blob
            try {
                const response = await request.get(`/payroll-receipts/${receipt.id}/download`, {}, { responseType: 'blob' });
                
                if (response.data) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', receipt.filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            } catch (error) {
                console.error('Download error:', error);
                this.$swal({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    icon: 'error',
                    title: 'Error al descargar el archivo'
                });
            }
        }
    }
};
</script>

<style scoped>
/* Colores personalizados */
.text-teal { color: #0f766e !important; }
.bg-teal { background-color: #0f766e !important; }
.btn-teal {
    background-color: #0f766e;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    transition: all 0.2s;
}
.btn-teal:hover {
    background-color: #0d6e66;
    transform: translateY(-1px);
}

.btn-icon {
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.hover-scale:hover {
    transform: scale(1.1);
    background-color: #e6fffa;
    color: #0d9488 !important;
}

.text-gray-800 { color: #1f2937; }
.text-gray-300 { color: #d1d5db; }
.bg-light-gray { background-color: #f9fafb; }

.text-xs { font-size: 0.75rem; }
.border-light { border-color: #e5e7eb !important; }

/* Tabla */
.custom-table th {
    letter-spacing: 0.05em;
}
.custom-table td {
    color: #4b5563;
    font-size: 0.9rem;
}
</style>
